const ProgressBar = ({ progress, backgroundColor }: {
  progress: number,
  backgroundColor?: string,
}) => (
  <div className="relative w-full bg-gray-200 rounded-full h-4">
    <div
      className="h-full rounded-full"
      style={{
        width: `${progress}%`,
        backgroundColor: backgroundColor ?? 'rgb(0, 94, 184)',
      }}
    ></div>
    <div className="absolute inset-0 flex items-center justify-center text-white font-bold">
      {progress}%
    </div>
  </div>
);

export default ProgressBar;
